const tagsTypes = {

  get: {
    request: "GET_TAG_REQUEST",
    success: "GET_TAG_SUCCESS",
    failure: "GET_TAG_FAILURE"
  },

  index: {
    request: "TAGS_INDEX_REQUEST",
    success: "TAGS_INDEX_SUCCESS",
    failure: "TAGS_INDEX_FAILURE"
  },

  create: {
    init:    "CREATE_TAG_INIT",
    request: "CREATE_TAG_REQUEST",
    success: "CREATE_TAG_SUCCESS",
    failure: "CREATE_TAG_FAILURE"
  },

  update: {
    request: "UPDATE_TAG_REQUEST",
    success: "UPDATE_TAG_SUCCESS",
    failure: "UPDATE_TAG_FAILURE"
  },
  destroy: {
    request: "DESTROY_TAG_REQUEST",
    success: "DESTROY_TAG_SUCCESS",
    failure: "DESTROY_TAG_FAILURE"
  },

  set_errors: "SET_TAG_ERRORS",

  reset: "RESET_TAG"

}

export default tagsTypes



// WEBPACK FOOTER //
// ./src/js/constants/tagsTypes.js